import dotVariables from "@krystal/css/components/dot.css?inline";
import { unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { html, unsafeStatic } from "lit/static-html.js";
import EkoElement from "@/utilities/element";
import { getSafeTag, type Tag } from "@/utilities/html";
import theme from "./css/theme.css?inline";
import style from "./dot.css?inline";

@customElement("eko-dot")
class Dot extends EkoElement {
  static styles = [
    ...EkoElement.styles,
    unsafeCSS(dotVariables),
    unsafeCSS(style),
    unsafeCSS(theme),
  ];

  @property() as: Tag = "span";
  @property({ reflect: true }) size: "xs" | "sm" | "md" | "lg" | "xl" = "md";
  @property({ reflect: true }) theme: string = "default";

  render() {
    return html`
      <${unsafeStatic(this.tag)} class="eko-dot" part="root">
        <eko-visually-hidden>
          <slot></slot>
        </eko-visually-hidden>
      </${unsafeStatic(this.tag)}>
    `;
  }

  get tag() {
    return getSafeTag(this.as);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-dot": Dot;
  }
}

export default Dot;
